import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ElementRef, HostListener, Renderer2, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tooltip-action-list',
  templateUrl: './tooltip-action-list.component.html',
  styleUrls: ['./tooltip-action-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TooltipActionListComponent implements OnInit, OnDestroy {
  @Input() actionItems;
  @Output() clickAction: EventEmitter<string> = new EventEmitter<string>();

  public top: number;
  public singleClass: string = '';
  public sideNav;

  private _removeMouseEnterListener;
  private _removeMouseClickListener;
  private _navScrollListener;

  constructor(private _elRef: ElementRef, private _renderer: Renderer2, private _changeDetector: ChangeDetectorRef) {
    this._removeMouseEnterListener = this._renderer.listen(this.parent, 'mouseenter', () => {
      this._setPosition();
    });

    this._removeMouseClickListener = this._renderer.listen(this.parent, 'click', (event) => {
      this._setOpenClassOnClick(event);
    });

    this.sideNav = document.querySelector('.bc-sidenav');
  }

  ngOnInit(): void {
    this._setPosition();
    this.parent.classList.add('tooltip-parent');
    this._setSingleClassIfOnlyOneActionAvailable();

    if (this.numberOfActionItems > 1) {
      this._navScrollListener = this._onSideNavScroll.bind(this);
      this.sideNav.addEventListener('scroll', this._navScrollListener, true);
    }
  }

  ngOnDestroy() {
    this._removeMouseEnterListener();
    this._removeMouseClickListener();

    if (this._navScrollListener) {
      this.sideNav.removeEventListener('scroll', this._navScrollListener, true);
      this._navScrollListener = null;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this._setOpenClassOnClick(event, false);
  }

  get parent() {
    return this._elRef.nativeElement.parentElement;
  }

  get numberOfActionItems(): number {
    return this.actionItems && this.actionItems.length || 0;
  }

  onClickAction(event, action: string): void {
    event.preventDefault();
    event.stopPropagation();

    this.parent.classList.remove('open');
    this.clickAction.emit(action);
  }

  private _setPosition(): void {
    const parentClientRects = this.parent.getClientRects()[0];

    if (!parentClientRects) {
      return;
    }

    const parentHeight = parentClientRects.height;

    this.top = parentClientRects.top + parentHeight / 2;
    this._changeDetector.detectChanges();
  }

  private _setSingleClassIfOnlyOneActionAvailable() {
    if (this.numberOfActionItems === 1 && this.actionItems[0] && this.actionItems[0].text) {
      this.singleClass = 'single';
    }
  }

  private _setOpenClassOnClick(event, toggle: boolean = true) {
    if (this.numberOfActionItems === 1) {
      return;
    }

    const classList = event.currentTarget.classList;

    if (classList && classList.contains('tooltip-parent')) {
      event.stopPropagation();
    }

    if (toggle) {
      return this.parent.classList.toggle('open');
    }

    return this.parent.classList.remove('open');
  }

  private _onSideNavScroll() {
    this.parent.classList.remove('open');
  }
}
